import Swiper from 'swiper';
import { Navigation, Virtual, A11y, Pagination } from 'swiper/modules';
import 'swiper/css';

const defaultOptions = {
    modules: [Navigation, Virtual, A11y, Pagination],
    direction: 'horizontal',
    spaceBetween: 12,
    slidesPerView: 3.2,
    centerInsufficientSlides: true,
    breakpoints: {
        600: {
            slidesPerView: 4.2,
        },
        768: {
            slidesPerView: 6.2,
        },
        1024: {
            slidesPerView: 8.2,
        },
    },
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    a11y: {
        prevSlideMessage: 'Forrige slide',
        nextSlideMessage: 'Næste slide',
    },
};

document.querySelectorAll('.swiper:not(.mobile-swiper)').forEach(function (el) {
    new Swiper(el, defaultOptions);
});

const metricsOptions = {
    ...defaultOptions,
    slidesPerView: 1.2,
    breakpoints: {
        768: {
            slidesPerView: 2.1,
        }
    },
};

let metricsSwiper = null;

function toggleSwiperClasses(enable) {
    const slides = document.querySelectorAll('.metrics-list .metrics-item');
    slides.forEach((slide) => {
        if (enable) {
            slide.classList.add('swiper-slide');
        } else {
            slide.classList.remove('swiper-slide');
        }
    });
}

function initMetricsSwiper() {
    const metricsContainer = document.querySelector('.metrics-list');

    if (!metricsContainer) return;

    if (window.innerWidth < 1024) {
        toggleSwiperClasses(true);

        if (!metricsSwiper) {
            metricsSwiper = new Swiper(metricsContainer, metricsOptions);
        }
    } else {
        toggleSwiperClasses(false);

        if (metricsSwiper) {
            metricsSwiper.destroy(true, true);
            metricsSwiper = null;
        }
    }
}

window.addEventListener('load', initMetricsSwiper);
window.addEventListener('resize', initMetricsSwiper);

const newsOptions = {
    ...defaultOptions,
    slidesPerView: 1.2,
    spaceBetween: 24,
    breakpoints: {
        768: { slidesPerView: 2 }
    },
};

document.querySelectorAll('.news-slider').forEach((el) => {
    const newsSwiper = new Swiper(el, newsOptions);
    newsSwiper.update();
    newsSwiper.slideTo(0, 0);
});